import { API_ROOT_URL } from '../config';
import axios from 'axios';

export const CounsellorsService = {
	fetchCounsellors,
	saveCounsellors,
	fetchLanguages,
	fetchServiceType
};

function fetchCounsellors() {
	const token = JSON.parse(localStorage.getItem('token'));
	const requestOptions = {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			Authorization: 'Bearer ' + token,
		},
	};
	return fetch(`${API_ROOT_URL}/administrator/counsellor/`, requestOptions).then((response) => response.json());
}

function fetchLanguages() {
	const requestOptions = {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
		},
	};
	return fetch(`${API_ROOT_URL}/projects/languages/`, requestOptions).then((response) => response.json());
}

function fetchServiceType() {
	const token = JSON.parse(localStorage.getItem('token'));
	const requestOptions = {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			Authorization: 'Bearer ' + token,
		},
	};
	return fetch(`${API_ROOT_URL}/administrator/service-type/`, requestOptions).then((response) => response.json());
}

function saveCounsellors(data, id='') {
	const token = JSON.parse(localStorage.getItem('token'));
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: 'Bearer ' + token,
			data,
		},
	};
	//return fetch(`${API_ROOT_URL}/administrator/project/`, requestOptions).then((response) => response.json());
	if (id === '') {
		return axios
			.post(`${API_ROOT_URL}/administrator/counsellor/`, data, {
				headers: {
					'Content-Type': 'application/json',
					Authorization: 'Bearer ' + token,
				},
			})
			.then((response) => response);
	} else {
		return axios
			.put(`${API_ROOT_URL}/administrator/counsellor/${id}/`, data, {
				headers: {
					'Content-Type': 'application/json',
					Authorization: 'Bearer ' + token,
				},
			})
			.then((response) => response);
	}
}



// WEBPACK FOOTER //
// ./src/services/counsellors.service.js